export default {"src":"/_next/static/media/arrow-right-white.107b275d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};